(ns bec-cljs-common.components.input
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.i18n :as i18n]))

(defn input-regex [props]
  (let [regex-type (or (:regex-type props) props)
        regex (:regex props)]
    (case regex-type
      :alphanumeric #"^[a-zA-Z0-9]{1,50}$"
      :capital-alphanumeric #"^[A-Z0-9]{1,50}$"
      :capital-alphanumeric-with-hyphen #"^[A-Z0-9-]{1,50}$"
      :number #"^[0-9.-]{2,50}$"
      :email #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$"
      regex)))

(defn validate-user-input [input regex-info]
  (if (and (not (nil? input)) (string? input))
    (string? (first (re-seq (input-regex regex-info) input)))))

(rf/reg-event-fx
  :keyboard-button-press
  (fn [{:keys [db]} [_ props]]
    (let [keypad-id (:keypad-id props)
          input (:input props)
          regex-props (:regex-props props)
          input-max-length (:input-max-length props)
          key-press-event-fn (:key-press-event-fn props)
          regex-result (when regex-props (validate-user-input input regex-props))
          input-max-length (or input-max-length 50)]
      (if (>= input-max-length (count input))
        (merge
          {:db (cond
                 key-press-event-fn
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :input-prompt] nil))
                 regex-props
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :valid-input?] regex-result)
                   (assoc-in [:keypad keypad-id :input-prompt] nil))
                 :else
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :input-prompt] nil)
                   (assoc-in [:keypad keypad-id :valid-input?] nil)))}
          (when (fn? key-press-event-fn)
            (let [function-result (key-press-event-fn
                                    (merge
                                      (dissoc props :key-press-event-fn)
                                      {:keyboard-button-press? true
                                       :regex-result regex-result}))]
              (when (vector? function-result)
                {:fx [[:dispatch function-result]]}))))
        {:db (-> (assoc-in db [:keypad keypad-id :valid-input?] false)
               (assoc-in [:keypad keypad-id :input-prompt] (i18n/get [:keypad-reached-maximum-character-limit])))}))))

(defn is-valid-input-icon [valid?]
  [:i.fas.fade-in
   {:class (if valid? "fa-check" "fa-exclamation-triangle")
    :style {:display (when (nil? valid?) "none")
            :color (if valid? "var(--green)" "var(--red)")}}])

(defn field-control [& [props]]
  [:div.field
   (merge
     {:style {:margin-bottom "0.4rem"}}
     (:field-props props))
   (into
     [:div.control
      (when (map? props)
        (dissoc props :field-props))]
     (r/children (r/current-component)))])

(defn input [& [props]]
  (into
    [:input.input
     (merge
       (dissoc props
         :active-input?
         :valid-input?)
       {:class (str (when (and (not (nil? (:valid-input? props))) (:active-input? props))
                      (if (:valid-input? props)
                        " is-success "
                        " is-danger "))
                 (:class props))})]
    (r/children (r/current-component))))


(defn prompt-message [props prompt]
  [:p.input-prompt
   (merge
     (dissoc props :valid-input? :show-prompt?)
     {:style (merge {:transform (if (and prompt (not (= "" prompt)) (not (:hide-prompt? props)))
                                  "translateY(0) scale(1)"
                                  "translateY(-2rem) scale(0)")}
               (:style props))})
   prompt])

(defn field-input [{:keys [size
                           control-props
                           input-props
                           valid-input?
                           active-input?
                           prompt
                           prompt-props
                           icon-left
                           icon-left-props
                           icon-right
                           icon-right-props]}]
  [field-control
   (merge
     control-props
     {:class (str
               (when icon-left
                 " has-icons-left ")
               (when-not (false? icon-right)
                 " has-icons-right ")
               (:class control-props))
      :style (merge {:font-size size}
               (:style control-props))})
   [input
    (merge
      {:active-input? active-input?
       :valid-input? valid-input?}
      input-props
      {:style (merge 
                {:font-size size
                 :z-index (when prompt 1)}
                (:style input-props))})]
   (when icon-left
     [(if (:on-click icon-left-props) :button.is-clickable :span)
      (merge
        {:class "icon is-left"}
        icon-left-props)
      (if (string? icon-left)
        [:i {:class icon-left}]
        icon-left)])
   (when-not (false? icon-right)
     [(if (:on-click icon-right-props) :button.is-clickable :span)
      (merge
        icon-right-props
        {:class (str (:class icon-right-props) " icon is-right ")
         :style (merge (when (:on-click icon-right-props) {:pointer-events "auto"})
                  (:style icon-right-props))})
      (if icon-right
        (if (string? icon-right)
          [:i {:class icon-right}]
          icon-right)
        (when active-input?
          [is-valid-input-icon valid-input?]))])
   [prompt-message
    (merge prompt-props
      {:class (str (:class prompt-props)
                (cond
                  valid-input?
                  " is-success "
                  (false? valid-input?)
                  " is-danger "
                  (nil? valid-input?)
                  " is-info "
                  :else nil))})
    prompt]])

(defonce variables (r/atom {}))

(rf/reg-sub :radio
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:radio id] nil)
      (:radio @variables))))

(rf/reg-sub :checkbox
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:checkbox id] nil)
      (:checkbox @variables))))

(defn radio [& [props]]
  (let [radio-key (or (:radio-key props) (:id props) (str (:name props) "-" (:value props)))]
    (into
      [:label.panel-block
       [:input
        (merge
          (when (map? props) props)
          {:on-change (fn [event]
                        (when (fn? (:on-change props))
                          ((:on-change props) event))
                        (swap! variables
                          (fn [a]
                            (-> (assoc-in a [:radio (:name props)] {})
                              (assoc-in [:radio (:name props) radio-key] (:value props))))))
           :checked (not (nil? (get-in @variables [:radio (:name props) radio-key] nil)))
           :type "radio"})]]
      (r/children (r/current-component)))))

(defn checkbox [& [props]]
  (let [checkbox-key (or (:checkbox-key props) (:id props) :default-checkbox-key)]
    (into
      [:label.panel-block
       {:class (:outer-class props)
        :style (:outer-style props)}
       [:input
        (merge
          (when (map? props) (dissoc props
                               :outer-style
                               :outer-class
                               :checkbox-key))
          {:on-key-up (fn [event]
                        (when (fn? (:on-key-up props))
                          ((:on-key-up props) event))
                        (when (or (= event.key "Enter") (= event.keyCode 13))
                          (swap! variables assoc-in [:checkbox checkbox-key] (not (.-checked (.-target event))))))
           :on-change (fn [event]
                        (when (fn? (:on-change props))
                          ((:on-change props) event))
                        (swap! variables assoc-in [:checkbox checkbox-key] (.-checked (.-target event))))
           :checked (get-in @variables [:checkbox checkbox-key]
                      (if (nil? (:checked props)) false (:checked props)))
           :type "checkbox"})]]
      (r/children (r/current-component)))))

(defn switch [& [props]]
  (into
    [checkbox
     (merge
       (when (map? props) props)
       {:class (str (:class props) " is-switch ")})]
    (r/children (r/current-component))))
